import { motion } from "framer-motion";
import Image from "next/image";

const BudgetChatLoadingPlaceholder: React.FC = () => {
  return (
    <>
      <div className="flex flex-row">
        <div className="flex items-start space-x-2">
          <div className="relative h-8 w-8 rounded-full bg-light-background">
            <Image
              src="https://images.luminews.my/profile+image+Basic+R.png"
              alt={"Lumi AI Bot"}
              layout="fill"
              objectFit="cover"
            />
          </div>
          <div className="mt-2 flex flex-col">
            <div className="flex flex-row space-x-1">
              {Array.from([0, 1, 2]).map((index) => {
                return (
                  <>
                    <motion.div
                      key={index}
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1.2 }}
                      transition={{
                        repeat: Infinity,
                        repeatType: "reverse",
                        ease: "easeOut",
                        duration: 0.3,
                        type: "tween",
                        delay: index * 0.15,
                      }}
                    >
                      <div className="h-2 w-2 rounded-2xl bg-light-background"></div>
                    </motion.div>
                  </>
                );
              })}
            </div>
            <div className="h-screen"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BudgetChatLoadingPlaceholder;
